import React from 'react';

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

import studyAcademyLogo from '@common/assets/images/study-academy-logo.png';
import studyLyceumLogo from '@common/assets/images/study-lyceum-logo.png';

export const academyData = [
	{ logo: studyAcademyLogo },
	{ text: 'координатора програми (Міжнародної школи, SK\\ST\\RE Online)' },
	{ text: 'старшого викладача вашої локації.' },
];

export const lyceumData = [{ logo: studyLyceumLogo }, { text: 'керівника вашої локації.' }];

export const communicationRules = [
	{ title: 'Мова спілкування:', text: 'англійська або українська;' },
	{ title: 'Academy:', text: 'на відповідь учням надається 48 годин у межах робочих днів;' },
	{
		title: 'Lyceum:',
		text: 'на відповідь учням і батькам надається 24 години в межах робочих днів;',
	},
];

export const communicationRulesBulletList = [
	{
		text: 'спілкуйтесь з учнями та батьками приязно та ввічливо, ставтесь з повагою до їхніх запитань та запитів1',
	},
	{
		text: 'формулюйте відповіді так, щоб вони були зрозумілими як для учнів, так і для батьків. Якщо потрібно більше інформації, уточніть деталі',
	},
	{ text: 'уникайте обговорення інших учнів чи ситуацій, що не стосуються конкретного запитання' },
	{
		text: 'передавайте запити, які виходять за межі вашої відповідальності, координатору програми або керівнику протягом 24 годин з моменту отримання запиту.',
	},
];

export const copyCardData = [
	{
		title: 'Добрий день, дякую за запитання!',
		text: `Я передам цей запит _________________, вона/він сконтактує з вами та надасть необхідні деталі.
           Якщо маєте якісь запитання щодо домашніх завдань чи наповнення курсу, з радістю допоможу тут у чаті!`,
	},
	{
		title: 'Дякую, що написали!',
		text: `Ваше запитання важливе, і я вже передав(-ла) його _________________________. Вони зв’яжуться з вами, щоб усе уточнити.
           Якщо я можу допомогти з матеріалами уроків або завданнями, дайте знати. Гарного вам дня та приємного навчання!`,
	},
	{
		title: 'Добрий день!',
		text: `Дякую за звернення. Це питання найкраще вирішить _________________, тому я передам його їй/йому. Якщо у вас будуть запитання щодо уроків чи матеріалів,
           обов’язково пишіть, із радістю допоможу. Гарного дня!`,
	},
];

export const requestExamplesConfig = [
	{
		title: '',
		subtitle: 'Відповідає викладач',
		items: [
			'Учні запитують про те, чи правильно вони зрозуміли завдання.',
			'Учні цікавляться можливістю виправити оцінку.',
			'Учні запитують, де знайти пояснення до вправи.',
			'Учні цікавляться, чому там помилка, коли вони думали, що відповіли правильно.',
		],
	},
	{
		title: studyAcademyLogo,
		subtitle: 'Спрямовує до координатора або cтаршого викладача',
		items: [
			'Учні запитують про наступні модулі програми.',
			'Учні цікавляться вступом, реєстрацією на іспит IELTS, іншими продуктами.',
			'Учні пишуть, що їм не подобається в групі, некомфортно, не цікаво. Загалом будь-який вид незадоволення навчальним процесом.',
			'Учні цікавляться можливістю змінити групу або можливістю виконати урок повторно (анулювати).',
			'Учні звертаються щодо технічних або граматичних помилок на платформі.',
		],
	},
	{
		title: studyLyceumLogo,
		subtitle: 'Спрямовує до керівника локації',
		items: [
			'Учні/батьки запитують про зміну класу.',
			'Учні цікавляться вступом, реєстрацією на іспит IELTS, іншими продуктами.',
			'Учні пишуть, що їм не подобається в групі, некомфортно, не цікаво. Загалом будь-який вид незадоволення навчальним процесом.',
			'Учні звертаються щодо технічних або граматичних помилок на платформі.',
		],
	},
];

export const requestRulesConfig = [
	{
		text: 'Викладач не коментує в чаті програму загалом, план програми, питання вступу, офіційних іспитів, переведення між групами тощо.',
		icon: '!',
	},
	{
		text: 'Такі питання клієнт має вирішувати з операційною командою (координатором програми, старшим викладачем або керівником локації).',
		subText:
			'За потреби вони залучають інші відділи для вирішення ситуації після детального опрацювання питання.',
		icon: <CheckOutlinedIcon />,
	},
];
